export const stringMapDefault = {
    remove: "Remove"
};
